import React from 'react';

import {useParams} from 'react-router-dom';

import {Head, LoadError, GoogleMapProvider} from '@wheeebo/polaris-ui';

import NoFlyZoneUpdateForm from '@components/form/NoFlyZoneUpdateForm';

function NoFlyZonePage(): JSX.Element {
  const params = useParams();
  return (
    <GoogleMapProvider>
      <Head title="No fly zones" />
      {params.noFlyZoneId ? <NoFlyZoneUpdateForm noFlyZoneId={params.noFlyZoneId} /> : <LoadError />}
    </GoogleMapProvider>
  );
}

export default React.memo(NoFlyZonePage);
